import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login.service';
import { Router } from '@angular/router';
import { StateStorageService } from '../shared/auth/state-storage.service';
import { DataStorageService } from '../shared/data-storage.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { LoaderService } from '../shared/loader/loader.service';
import { ErrorClass } from '../error/error-class';
import { NGXLogger } from 'ngx-logger';
import { ActivatedRoute } from '@angular/router';
import { User } from '../shared/auth/user';
import { TranslateService } from '../../../node_modules/@ngx-translate/core';
import { Subscription } from '../../../node_modules/rxjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
declare var AesUtil: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    authenticationError: boolean;
    id_token: string;
    token: string;
    user: User;
    userLoggedIn: User;
    username: String;
    password: String;
    errormessage: string = "";
    accessdenied: boolean = false;
    isReady: boolean = false;
    subscription: Subscription;
    lang: string;
    ture: any;
    show: boolean;
    hide: boolean;
    constructor(
        private translate: TranslateService,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private dataStorageService: DataStorageService,
        private router: Router,
        private http: HttpClient,
        private loaderService: LoaderService,
        private logger: NGXLogger,
        private activatedRoute: ActivatedRoute,
        private localService: LocalStorageService,
        private sessionStorage: SessionStorageService

    ) {

    }
    ngOnInit() {

        this.show = true;
        //this.logger.debug('login component is called');
        // this.localService.clear('authenticationToken');
        // this.sessionStorage.clear('authenticationToken');
        // localStorage.clear();
        // sessionStorage.clear();
        // localStorage.setItem("lang", "en");
        window.scroll(0, 0);
        // this.loginService.logout();
        this.userLoggedIn = JSON.parse(localStorage.getItem("sessuser")) as User;
        //console.log('this user is>>>', this.userLoggedIn);
        if (this.userLoggedIn != undefined) {
            this.loginService.redirectTo(this.userLoggedIn,null);
        }
        this.translate.use("en");
        this.isReady = true;
    }

    login() {
        this.loaderService.show();
        //this.logger.debug("going to authenticate user -> ");
        this.userLoggedIn=JSON.parse(localStorage.getItem("sessuser")) as User;
        if (this.userLoggedIn == undefined) {
            this.user = new User();
            this.loginService.login({
                username: this.username.trim(),
                password: this.password
            }).then((data: User) => {
                localStorage.setItem("lang", "en");
                this.isReady = false;
                this.loaderService.hide();
                //this.logger.debug("data before login.." + JSON.stringify(data));
                this.user = data ;
                //this.logger.debug("data in login.." + JSON.stringify(this.user));
                this.authenticationError = false;
                this.dataStorageService.setUserData(data );
                //sessionStorage.setItem("sessuser", JSON.stringify(this.user));
                localStorage.setItem("sessuser", JSON.stringify(data));
                sessionStorage.setItem("sessuser", JSON.stringify(data));
                // sessionStorage.setItem("sessuser", JSON.stringify(data));

                //this.logger.debug('url... ' + this.router.url);
                if (this.router.url === '/register' || (/^\/activate\//.test(this.router.url)) ||
                    (/^\/reset\//.test(this.router.url))) {
                    this.router.navigate(['']);
                }
                this.loginService.redirectTo(this.user, null);

            }).catch((err: HttpErrorResponse) => {
                //this.logger.debug('login err in login component...' + err.error)
                if (err.error.qwertyuiopasdfghjklzxcvbnm != undefined) {
                    var iterationCount = 1000;
                    var keySize = 128;
                    var aesUtil = new AesUtil(keySize, iterationCount);
                    const ciphertext2 = aesUtil.decrypt("8bc82ffe516ea1f1b89dcb529a201d56", "ebb7947b5feabdc0b60f2a694fa259c4", "aks@Samuel#Rishi", err.error.qwertyuiopasdfghjklzxcvbnm);
                    //console.log('ciphertext2 is >>>>', ciphertext2);
                    //err=err.clone({error:ciphertext2});
                    //console.log('error is >>>>>>>', ciphertext2);
                    var errorObj = JSON.parse(ciphertext2);
                }

                if (errorObj instanceof Error) {
                    //this.logger.debug('Login An error occured in login component... ' + errorObj)
                } else {
                    //this.logger.debug('Login Backend returned code ' + err.status + ',' + ' body was: ' + err.status);
                }
                this.authenticationError = true;
                this.dataStorageService.storage = new ErrorClass(err.name, err.status, err.message, '');
                // alert(err == null);
                // alert(err.error == null);
                if (err.status == 401) {
                    this.loaderService.hide();
                    // this.errormessage = errorObj.AuthenticationException;
                    this.errormessage = "Invalid username or password."
                } else if (errorObj == null) {
                    this.accessdenied = true;
                } else {
                    let link = ['/error'];
                    this.router.navigate(link);
                }

            });
        }else{
            if(this.userLoggedIn.user_id==this.username){
                this.loginService.redirectTo(this.userLoggedIn,null);
            }else{
                this.loaderService.hide();
                this.errormessage="You are already logged in with some other user. Please logout and then retry with different username and password.";
            }
        }
    }
    // ontest() {
    //     this.billerservice.testHit().subscribe(data => {
    //         //this.logger.debug('service is hit...' + data);
    //     })
    // }

    //redirect user base on role



    showPassword(input: any): any {
        input.type = input.type === 'password' ? 'text' : 'password';
        this.hide = true;
        this.show = false;
    }
    hidePassword(input: any): any {
        input.type = input.type === 'password' ? 'text' : 'password';
        this.hide = false;
        this.show = true;
    }

    flagInputU = false;
    flagInputP = false;
    // checkInputLegth(obj) {

    //     if (obj == 'u' && obj) {
    //         this.flagInputU = this.username.length >= 5 ? true : false;
    //     } else if (obj == 'p' && obj) {
    //         this.flagInputP = this.password.length >= 8 ? true : false;
    //     }
    // }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts